import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Text from '../../../../shared/Text';
import { TileImage } from '../Tiles/TileImage.jsx';

export const TileCard = ({ tile }) => {
  return (
    <Container>
      <TileImage
        thumbnail={tile.thumbnail}
        ribbonTagName={tile.ribbonTagName}
        ribbonTagColor={tile.ribbonTagColor}
      />
      <Headline variant="small1">{tile.headline}</Headline>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  position: relative;
  width: 190px;
  height: 218px;
  box-shadow: 0 2px 3px rgb(0 0 0 / 22%);
`;

const Headline = styled(Text)`
  padding: 10px;
`;
